import React from 'react'
import { useGame } from '../contexts/GameContext'

export const UI: React.FC = () => {
  const { gameState } = useGame()

  return (
    <div className="ui-overlay">
      {/* Score counter */}
      <div className="score-display">
        Score: {gameState.score}
      </div>

      {/* Swipe indicator (for debugging) */}
      {/* Removed red rectangle overlay for swipe selection */}

      {/* Instructions during game - only show once */}
      {!gameState.gameStarted && !gameState.isGameOver && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-lg text-center">
          <p className="text-sm">
            Swipe to shoot the ball towards the crossbar
          </p>
        </div>
      )}
    </div>
  )
}
